@if (params.context.componentParent.showRowInEditMode(params.node)) {
<mat-select [(ngModel)]="selectedSymbolId" (ngModelChange)="setIconFromSymbol(selectedSymbol)">
  @for (orderStatus of orderStatuses; track getIdentifier($index, orderStatus)) {
  <mat-option class="symbol-option" [value]="orderStatus.id">
    <fa-icon class="col-3" [icon]="getIconFromSymbol(orderStatus.symbol)"></fa-icon>
    <span class="flex-fill ms-2">{{ orderStatus.description }}</span>
  </mat-option>
  }
</mat-select>
} @if (params.context.componentParent.showRowInViewMode(params.node)) {
<fa-icon [icon]="icon" [matTooltip]="tooltip" [ngStyle]="{ color: getColor(params) }"> </fa-icon>
}
